import React from 'react'
import Modal from 'react-bootstrap/Modal'

import moment from 'moment'

import EngagementCard from './EngagementCard'

export default class PromoteShopEngagementCard extends React.Component {
  render(){
    // to do set the props for sizing here
    return (
      <EngagementCard
        { ...this.props }
        title="Promote Your Shop"
        renderContent={() => "Your shop and products are live. Share your shop link on social media and your customers."}
        cta="Open Shop Link"
      />
    )
  }
}
